import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { USER_DATA_IN_LOCAL_STORAGE } from '../../../utils/constants';

interface IUser {
  childDateOfBirth: string;
  childName: string;
  motherOrFatherName: string;
}

interface IBirthInfoProps {
  currentUser?: IUser | null;
}

const BirthInfo: React.FC<IBirthInfoProps> = ({ currentUser }) => {
  const { t } = useTranslation();
  const readOnlyUserInfo: IUser | null = useSelector(
    (state: any) => state.authentication.userData
  );

  const localUserInfo = useMemo(() => {
    const user = localStorage.getItem(USER_DATA_IN_LOCAL_STORAGE);
    if (!user) {
      return null;
    }

    try {
      const parsedUser = JSON.parse(user);
      return {
        childDateOfBirth: parsedUser.childDateOfBirth,
        childName: parsedUser.childName,
        motherOrFatherName: parsedUser.motherOrFatherName,
      } as IUser;
    } catch (error) {
      console.error('Failed to parse local user data in BirthInfo:', error);
      return null;
    }
  }, []);

  const resolvedUserInfo = currentUser || readOnlyUserInfo || localUserInfo;
  const formattedBirthDate = useMemo(() => {
    const rawBirthDate = resolvedUserInfo?.childDateOfBirth;
    if (!rawBirthDate) {
      return '';
    }

    const normalizedBirthDate = rawBirthDate.split('T')[0].trim();
    const parsedDate = moment(
      normalizedBirthDate,
      ['YYYY-MM-DD', 'DD.MM.YYYY', moment.ISO_8601],
      true
    );
    if (parsedDate.isValid()) {
      return parsedDate.format('DD.MM.YYYY');
    }

    const splitDate = normalizedBirthDate.split('-');
    if (splitDate.length === 3) {
      return `${splitDate[2]}.${splitDate[1]}.${splitDate[0]}`;
    }

    return normalizedBirthDate;
  }, [resolvedUserInfo?.childDateOfBirth]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div id="birth-info">
        <span
          style={{
            display: 'block',
            fontSize: '13px',
            lineHeight: '18px',
            color: '#4A4A4A',
          }}
        >
          {t('analytics:shared.birth-box.birth')}
        </span>
        <span style={{ fontSize: '14px', color: '#4A4A4A' }}>
          {formattedBirthDate}
        </span>
      </div>
    </div>
  );
};

export default BirthInfo;
